(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-bet-accepted.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-bet-accepted.js');
"use strict";


const {
  services,
  logger
} = svs.sportsbook.sbtech_api_impl;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_betAccepted = (_, internals) => purchaseIDs => {
  services.accountBalance(() => {}, true);
  let wagerIds = purchaseIDs || [];
  if (wagerIds.length === 0 && Object.keys(wagerIds).length > 0) {
    wagerIds = Object.keys(purchaseIDs);
  }
  if (internals.lastBetPlacedTimestamp) {
    logger.info("time spent processing bet: ".concat(Date.now() - internals.lastBetPlacedTimestamp, " ms. [").concat(wagerIds.join(', '), "]"));
    delete internals.lastBetPlacedTimestamp;
  }
};

 })(window);